// extracted by mini-css-extract-plugin
module.exports = {"files-section-wrapper":"FilesSection_files-section-wrapper___IMnP","files-section":"FilesSection_files-section__fO1v3"};